app.controller('Menu', function ($scope) {
	$scope.selectedItem = false;
	
	$scope.menuAmount =  6;
	$scope.menuShowAll = menu <= $scope.menuAmount;
	
});